/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// function voidSuspendedCartsQuery(): DataServiceQuery {
//       return new DataServiceQuery();
//       }

// export function voidSuspendedCartsInput (
//     suspendedCartIds:
//         string[],
//         reasonCodeLines:
//         Entities.ReasonCodeLine[]
// ): IDataServiceRequest {
//   const query = voidSuspendedCartsQuery();
//   return query.createDataServiceRequestForOperation(
//       'VoidSuspendedCarts',
//       true, Entities.Cart,
//       'false',
//       { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//       {
//       suspendedCartIds: suspendedCartIds,
//         reasonCodeLines: reasonCodeLines
//       }
//   );
// }

// export function voidSuspendedCartsAsync (
//     context: IContext, suspendedCartIds:
//         string[],
//         reasonCodeLines:
//         Entities.ReasonCodeLine[]
//     ): AsyncResult<Entities.Cart> {
//     const request = voidSuspendedCartsInput(suspendedCartIds, reasonCodeLines);
//     return callActionOrExecute<Entities.Cart>(request, context.callerContext);
//     }

// function iTSCLIGetAllSuspendedCartsQuery(): DataServiceQuery {
//       return new DataServiceQuery();
//       }

// export function iTSCLIGetAllSuspendedCartsInput (
//     suspendedTransactionFilter:
//         DataServiceEntities.IITSCLIGetAllSuspendedCartsAPIParams
// ): IDataServiceRequest {
//   const query = iTSCLIGetAllSuspendedCartsQuery();
//   return query.createDataServiceRequestForOperation(
//       'ITSCLIGetAllSuspendedCarts',
//       true,
//         DataServiceEntities.ITSCLIGetAllSuspendedCartsResponseExtensionClass
//       ,
//       'false',
//       { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSCLIGetAllSuspendedCartsResponse' },
//       {
//       suspendedTransactionFilter: suspendedTransactionFilter
//       }
//   );
// }

// export function iTSCLIGetAllSuspendedCartsAsync (
//     context: IContext, suspendedTransactionFilter:
//         DataServiceEntities.IITSCLIGetAllSuspendedCartsAPIParams
//     ): AsyncResult<DataServiceEntities.IITSCLIGetAllSuspendedCartsResponse> {
//     const request = iTSCLIGetAllSuspendedCartsInput(suspendedTransactionFilter);
//     return callActionOrExecute<DataServiceEntities.IITSCLIGetAllSuspendedCartsResponse>(request, context.callerContext);
//     }

function getActiveMenusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getActiveMenusInput(
    eventId: string,
    menuPriceSearchArgs: DataServiceEntities.IMenuPriceSearchArgs,
    lookAhead: boolean,
    includeDescription: boolean,
    languageId: string,
    forceIncludeProductImages: boolean
): IDataServiceRequest {
    const query = getActiveMenusQuery();
    return query.createDataServiceRequestForOperation(
        'GetActiveMenus',
        true,
        DataServiceEntities.GetActiveMenusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetActiveMenusResponse' },
        {
            eventId: eventId,
            menuPriceSearchArgs: menuPriceSearchArgs,
            lookAhead: lookAhead,
            includeDescription: includeDescription,
            languageId: languageId,
            forceIncludeProductImages: forceIncludeProductImages
        }
    );
}

export function getActiveMenusAsync(
    context: IContext,
    eventId: string,
    menuPriceSearchArgs: DataServiceEntities.IMenuPriceSearchArgs,
    lookAhead: boolean,
    includeDescription: boolean,
    languageId: string,
    forceIncludeProductImages: boolean
): AsyncResult<DataServiceEntities.IGetActiveMenusResponse> {
    const request = getActiveMenusInput(eventId, menuPriceSearchArgs, lookAhead, includeDescription, languageId, forceIncludeProductImages);
    return callActionOrExecute<DataServiceEntities.IGetActiveMenusResponse>(request, context.callerContext);
}

function iTSGetProductsInfoByIdsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function iTSGetProductsInfoByIdsInput(itemIds: string[]): IDataServiceRequest {
    const query = iTSGetProductsInfoByIdsQuery();
    return query.createDataServiceRequestForOperation(
        'ITSGetProductsInfoByIds',
        true,
        DataServiceEntities.ITSGetProductsInfoByIdResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSGetProductsInfoByIdResponse' },
        {
            itemIds: itemIds
        }
    );
}

export function iTSGetProductsInfoByIdsAsync(
    context: IContext,
    itemIds: string[]
): AsyncResult<DataServiceEntities.IITSGetProductsInfoByIdResponse> {
    const request = iTSGetProductsInfoByIdsInput(itemIds);
    return callActionOrExecute<DataServiceEntities.IITSGetProductsInfoByIdResponse>(request, context.callerContext);
}

function lAC_GetCartGratuityDataFromChannelProfileQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_GetCartGratuityDataFromChannelProfileInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    channelId: number,
    customerId: string
): IDataServiceRequest {
    const query = lAC_GetCartGratuityDataFromChannelProfileQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_GetCartGratuityDataFromChannelProfile',
        true,
        DataServiceEntities.GetCartGratuityDataResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCartGratuityDataResponse' },
        {
            authToken: authToken,
            cartId: cartId,
            channelId: channelId,
            customerId: customerId
        }
    );
}

export function lAC_GetCartGratuityDataFromChannelProfileAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    channelId: number,
    customerId: string
): AsyncResult<DataServiceEntities.IGetCartGratuityDataResponse> {
    const request = lAC_GetCartGratuityDataFromChannelProfileInput(authToken, cartId, channelId, customerId);
    return callActionOrExecute<DataServiceEntities.IGetCartGratuityDataResponse>(request, context.callerContext);
}

function lAC_AddGratuityWithCrossChannelProfileQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_AddGratuityWithCrossChannelProfileInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    transactionId: string,
    amount: number,
    channelId: number,
    customerId: string
): IDataServiceRequest {
    const query = lAC_AddGratuityWithCrossChannelProfileQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_AddGratuityWithCrossChannelProfile',
        true,
        DataServiceEntities.AddGratuityResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAddGratuityResponse' },
        {
            authToken: authToken,
            transactionId: transactionId,
            amount: amount,
            channelId: channelId,
            customerId: customerId
        }
    );
}

function lAC_ITSGetCustomerCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetCustomerCartInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string
): IDataServiceRequest {
    const query = lAC_ITSGetCustomerCartQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetCustomerCart',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'EntityClasses.CartClass' },
        {
            authToken: authToken,
            cartId: cartId,
            customerId: customerId
        }
    );
}

export function lAC_ITSGetCustomerCartAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string
): AsyncResult<Entities.Cart> {
    const request = lAC_ITSGetCustomerCartInput(authToken, cartId, customerId);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

export function lAC_AddGratuityWithCrossChannelProfileAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    transactionId: string,
    amount: number,
    channelId: number,
    customerId: string
): AsyncResult<DataServiceEntities.IAddGratuityResponse> {
    const request = lAC_AddGratuityWithCrossChannelProfileInput(authToken, transactionId, amount, channelId, customerId);
    return callActionOrExecute<DataServiceEntities.IAddGratuityResponse>(request, context.callerContext);
}

function getRestItemIdModifiersQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getRestItemIdModifiersInput(
    itemId: string,
    priceCalculationCriteria: DataServiceEntities.IModsPriceCalculationCriteria
): IDataServiceRequest {
    const query = getRestItemIdModifiersQuery();
    return query.createDataServiceRequestForOperation(
        'GetRestItemIdModifiers',
        true,
        DataServiceEntities.CreateCachedItemHospModsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateCachedItemHospModsResponse' },
        {
            ItemId: itemId,
            PriceCalculationCriteria: priceCalculationCriteria
        }
    );
}

export function getRestItemIdModifiersAsync(
    context: IContext,
    itemId: string,
    priceCalculationCriteria: DataServiceEntities.IModsPriceCalculationCriteria
): AsyncResult<DataServiceEntities.ICreateCachedItemHospModsResponse> {
    const request = getRestItemIdModifiersInput(itemId, priceCalculationCriteria);
    return callActionOrExecute<DataServiceEntities.ICreateCachedItemHospModsResponse>(request, context.callerContext);
}

// @ts-ignore
function diningTableInfoQuery(channelId?: number, eventId?: string, tableId?: string, transactionGroupId?: string): DataServiceQuery {
    const key =
        channelId && eventId && tableId && transactionGroupId
            ? { ChannelId: channelId, EventId: eventId, TableId: tableId, TransactionGroupId: transactionGroupId }
            : null;
    return new DataServiceQuery('DiningTableInfo', 'EventDiningTableInfo', DataServiceEntities.EventDiningTableInfoExtensionClass, key);
}

export function createGetEventsInput(
    queryResultSettings: IQueryResultSettings,
    includeFutureEvents: boolean,
    eventTypeId: string,
    includePastEvents: boolean,
    pastEventDaysAllowed: number
): IDataServiceRequest {
    const query = diningTableInfoQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetEvents',
        true,
        DataServiceEntities.RestaurantEventPerChannelViewExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IRestaurantEventPerChannelView' },
        {
            includeFutureEvents: includeFutureEvents,
            EventTypeId: eventTypeId,
            includePastEvents: includePastEvents,
            pastEventDaysAllowed: pastEventDaysAllowed
        }
    );
}

export function getEventsAsync(
    context: IContext,
    includeFutureEvents: boolean,
    eventTypeId: string,
    includePastEvents: boolean,
    pastEventDaysAllowed: number
): AsyncResult<DataServiceEntities.IRestaurantEventPerChannelView[]> {
    const request = createGetEventsInput(
        context.queryResultSettings || {},
        includeFutureEvents,
        eventTypeId,
        includePastEvents,
        pastEventDaysAllowed
    );
    return callActionOrExecute<DataServiceEntities.IRestaurantEventPerChannelView[]>(request, context.callerContext);
}

function getActiveMenusForChannelQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getActiveMenusForChannelInput(
    eventId: string,
    menuPriceSearchArgs: DataServiceEntities.IMenuPriceSearchArgs,
    channelId: number,
    lookAhead: boolean,
    includeDescription: boolean,
    languageId: string,
    forceIncludeProductImages: boolean
): IDataServiceRequest {
    const query = getActiveMenusForChannelQuery();
    return query.createDataServiceRequestForOperation(
        'GetActiveMenusForChannel',
        true,
        DataServiceEntities.GetActiveMenusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetActiveMenusResponse' },
        {
            eventId: eventId,
            menuPriceSearchArgs: menuPriceSearchArgs,
            channelId: channelId,
            lookAhead: lookAhead,
            includeDescription: includeDescription,
            languageId: languageId,
            forceIncludeProductImages: forceIncludeProductImages
        }
    );
}

export function getActiveMenusForChannelAsync(
    context: IContext,
    eventId: string,
    menuPriceSearchArgs: DataServiceEntities.IMenuPriceSearchArgs,
    channelId: number,
    lookAhead: boolean,
    includeDescription: boolean,
    languageId: string,
    forceIncludeProductImages: boolean
): AsyncResult<DataServiceEntities.IGetActiveMenusResponse> {
    const request = getActiveMenusForChannelInput(
        eventId,
        menuPriceSearchArgs,
        channelId,
        lookAhead,
        includeDescription,
        languageId,
        forceIncludeProductImages
    );
    return callActionOrExecute<DataServiceEntities.IGetActiveMenusResponse>(request, context.callerContext);
}

function lAC_GetActiveMenusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_GetActiveMenusInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    eventId: string,
    channelId: number,
    lookAhead: boolean,
    includeDescription: boolean,
    languageId: string,
    forceIncludeProductImages: boolean
): IDataServiceRequest {
    const query = lAC_GetActiveMenusQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_GetActiveMenus',
        true,
        DataServiceEntities.GetActiveMenusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetActiveMenusResponse' },
        {
            authToken: authToken,
            eventId: eventId,
            channelId: channelId,
            lookAhead: lookAhead,
            includeDescription: includeDescription,
            languageId: languageId,
            forceIncludeProductImages: forceIncludeProductImages
        }
    );
}

export function lAC_GetActiveMenusAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    eventId: string,
    channelId: number,
    lookAhead: boolean,
    includeDescription: boolean,
    languageId: string,
    forceIncludeProductImages: boolean
): AsyncResult<DataServiceEntities.IGetActiveMenusResponse> {
    const request = lAC_GetActiveMenusInput(
        authToken,
        eventId,
        channelId,
        lookAhead,
        includeDescription,
        languageId,
        forceIncludeProductImages
    );
    return callActionOrExecute<DataServiceEntities.IGetActiveMenusResponse>(request, context.callerContext);
}

export function createGetEventInfoInput(eventId: string): IDataServiceRequest {
    const query = diningTableInfoQuery();
    return query.createDataServiceRequestForOperation(
        'GetEventInfo',
        true,
        DataServiceEntities.RestaurantEventExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IRestaurantEvent' },
        { eventId: eventId }
    );
}

export function getEventInfoAsync(context: IContext, eventId: string): AsyncResult<DataServiceEntities.IRestaurantEvent> {
    const request = createGetEventInfoInput(eventId);
    return callActionOrExecute<DataServiceEntities.IRestaurantEvent>(request, context.callerContext);
}

function lAC_ITSGetEcom2RetailStoresQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetEcom2RetailStoresInput(
    queryResultSettings: IQueryResultSettings,
    authToken: DataServiceEntities.ILAC_AuthToken
): IDataServiceRequest {
    const query = lAC_ITSGetEcom2RetailStoresQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetEcom2RetailStores',
        true,
        DataServiceEntities.ITSEcom2RetailStoreExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSEcom2RetailStore' },
        {
            authToken: authToken
        }
    );
}

export function lAC_ITSGetEcom2RetailStoresAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken
): AsyncResult<DataServiceEntities.IITSEcom2RetailStore[]> {
    const request = lAC_ITSGetEcom2RetailStoresInput(context.queryResultSettings || {}, authToken);
    return callActionOrExecute<DataServiceEntities.IITSEcom2RetailStore[]>(request, context.callerContext);
}

function lAC_ITSEcomCheckoutQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSEcomCheckoutInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    paymentSelection: DataServiceEntities.ILAC_EcomPaymentSelection
): IDataServiceRequest {
    const query = lAC_ITSEcomCheckoutQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSEcomCheckout',
        true,
        DataServiceEntities.ITSEcomCheckoutResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSEcomCheckoutResponse' },
        {
            authToken: authToken,
            cartId: cartId,
            customerId: customerId,
            paymentSelection: paymentSelection
        }
    );
}

export function lAC_ITSEcomCheckoutAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    paymentSelection: DataServiceEntities.ILAC_EcomPaymentSelection
): AsyncResult<DataServiceEntities.IITSEcomCheckoutResponse> {
    const request = lAC_ITSEcomCheckoutInput(authToken, cartId, customerId, paymentSelection);
    return callActionOrExecute<DataServiceEntities.IITSEcomCheckoutResponse>(request, context.callerContext);
}

function lAC_ITSGetOrderStatusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetOrderStatusInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    storeCartId: string,
    channelId: number
): IDataServiceRequest {
    const query = lAC_ITSGetOrderStatusQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetOrderStatus',
        true,
        DataServiceEntities.ITSGetOrderStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSGetOrderStatusResponse' },
        {
            authToken: authToken,
            storeCartId: storeCartId,
            channelId: channelId
        }
    );
}

export function lAC_ITSGetOrderStatusAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    storeCartId: string,
    channelId: number
): AsyncResult<DataServiceEntities.IITSGetOrderStatusResponse> {
    const request = lAC_ITSGetOrderStatusInput(authToken, storeCartId, channelId);
    return callActionOrExecute<DataServiceEntities.IITSGetOrderStatusResponse>(request, context.callerContext);
}

function lAC_ITSGetOrderStateQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetOrderStateInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    storeOrderId: string,
    channelId: number
): IDataServiceRequest {
    const query = lAC_ITSGetOrderStateQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetOrderState',
        true,
        DataServiceEntities.LAC_StoreOrderStateExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILAC_StoreOrderState' },
        {
            authToken: authToken,
            storeOrderId: storeOrderId,
            channelId: channelId
        }
    );
}

export function lAC_ITSGetOrderStateAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    storeOrderId: string,
    channelId: number
): AsyncResult<DataServiceEntities.ILAC_StoreOrderState> {
    const request = lAC_ITSGetOrderStateInput(authToken, storeOrderId, channelId);
    return callActionOrExecute<DataServiceEntities.ILAC_StoreOrderState>(request, context.callerContext);
}

function lAC_ITSGetEcomCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetEcomCartInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    channelId: number,
    customerId: string,
    ecomCartId: string
): IDataServiceRequest {
    const query = lAC_ITSGetEcomCartQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetEcomCart',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        {
            authToken: authToken,
            cartId: cartId,
            channelId: channelId,
            customerId: customerId,
            ecomCartId: ecomCartId
        }
    );
}

export function lAC_ITSGetEcomCartAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    channelId: number,
    customerId: string,
    ecomCartId: string
): AsyncResult<Entities.Cart> {
    const request = lAC_ITSGetEcomCartInput(authToken, cartId, channelId, customerId, ecomCartId);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

function lAC_ITSResumeEcomCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSResumeEcomCartInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string
): IDataServiceRequest {
    const query = lAC_ITSResumeEcomCartQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSResumeEcomCart',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        {
            authToken: authToken,
            cartId: cartId,
            customerId: customerId
        }
    );
}

export function lAC_ITSResumeEcomCartAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string
): AsyncResult<Entities.Cart> {
    const request = lAC_ITSResumeEcomCartInput(authToken, cartId, customerId);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

function lAC_ITSGetAllCustomerEcomCartsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetAllCustomerEcomCartsInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    customerId: string,
    customerEcomCartsSearchCriteria: DataServiceEntities.IITSCustomerEcomCartsSearchCriteria
): IDataServiceRequest {
    const query = lAC_ITSGetAllCustomerEcomCartsQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetAllCustomerEcomCarts',
        true,
        DataServiceEntities.ITSGetAllCustomerEcomCartsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSGetAllCustomerEcomCartsResponse' },
        {
            authToken: authToken,
            customerId: customerId,
            customerEcomCartsSearchCriteria: customerEcomCartsSearchCriteria
        }
    );
}

export function lAC_ITSGetAllCustomerEcomCartsAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    customerId: string,
    customerEcomCartsSearchCriteria: DataServiceEntities.IITSCustomerEcomCartsSearchCriteria
): AsyncResult<DataServiceEntities.IITSGetAllCustomerEcomCartsResponse> {
    const request = lAC_ITSGetAllCustomerEcomCartsInput(authToken, customerId, customerEcomCartsSearchCriteria);
    return callActionOrExecute<DataServiceEntities.IITSGetAllCustomerEcomCartsResponse>(request, context.callerContext);
}

function lAC_ITSUpdateEcomCheckoutQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSUpdateEcomCheckoutInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    customerId: string,
    checkoutData: DataServiceEntities.IITSUpdateEcomCheckoutRequest,
    paymentSelection: DataServiceEntities.ILAC_EcomPaymentSelection
): IDataServiceRequest {
    const query = lAC_ITSUpdateEcomCheckoutQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSUpdateEcomCheckout',
        true,
        DataServiceEntities.ITSUpdateEcomCheckoutResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IITSUpdateEcomCheckoutResponse' },
        {
            authToken: authToken,
            customerId: customerId,
            checkoutData: checkoutData,
            paymentSelection: paymentSelection
        }
    );
}

export function lAC_ITSUpdateEcomCheckoutAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    customerId: string,
    checkoutData: DataServiceEntities.IITSUpdateEcomCheckoutRequest,
    paymentSelection: DataServiceEntities.ILAC_EcomPaymentSelection
): AsyncResult<DataServiceEntities.IITSUpdateEcomCheckoutResponse> {
    const request = lAC_ITSUpdateEcomCheckoutInput(authToken, customerId, checkoutData, paymentSelection);
    return callActionOrExecute<DataServiceEntities.IITSUpdateEcomCheckoutResponse>(request, context.callerContext);
}

function lAC_ITSGetRetailStoreAddressQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetRetailStoreAddressInput(channelId: number): IDataServiceRequest {
    const query = lAC_ITSGetRetailStoreAddressQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetRetailStoreAddress',
        true,
        EntityClasses.OrgUnitAddressClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.OrgUnitAddress' },
        {
            channelId: channelId
        }
    );
}

export function lAC_ITSGetRetailStoreAddressAsync(context: IContext, channelId: number): AsyncResult<Entities.OrgUnitAddress> {
    const request = lAC_ITSGetRetailStoreAddressInput(channelId);
    return callActionOrExecute<Entities.OrgUnitAddress>(request, context.callerContext);
}

function lAC_GetBasicUserInfoQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_GetBasicUserInfoInput(authToken: DataServiceEntities.ILAC_AuthToken): IDataServiceRequest {
    const query = lAC_GetBasicUserInfoQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_GetBasicUserInfo',
        true,
        DataServiceEntities.LAC_BasicUserInfoExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILAC_BasicUserInfo' },
        {
            authToken: authToken
        }
    );
}

export function lAC_GetBasicUserInfoAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken
): AsyncResult<DataServiceEntities.ILAC_BasicUserInfo> {
    const request = lAC_GetBasicUserInfoInput(authToken);
    return callActionOrExecute<DataServiceEntities.ILAC_BasicUserInfo>(request, context.callerContext);
}

function lAC_GetRefreshTokenQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_GetRefreshTokenInput(authToken: DataServiceEntities.ILAC_AuthToken): IDataServiceRequest {
    const query = lAC_GetRefreshTokenQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_GetRefreshToken',
        true,
        DataServiceEntities.LAC_RefreshTokenExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILAC_RefreshToken' },
        {
            authToken: authToken
        }
    );
}

export function lAC_GetRefreshTokenAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken
): AsyncResult<DataServiceEntities.ILAC_RefreshToken> {
    const request = lAC_GetRefreshTokenInput(authToken);
    return callActionOrExecute<DataServiceEntities.ILAC_RefreshToken>(request, context.callerContext);
}

function lAC_RemoveCartLinesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_RemoveCartLinesInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    cartLineIds: string[]
): IDataServiceRequest {
    const query = lAC_RemoveCartLinesQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_RemoveCartLines',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        {
            authToken: authToken,
            cartId: cartId,
            customerId: customerId,
            cartLineIds: cartLineIds
        }
    );
}

export function lAC_RemoveCartLinesAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    cartLineIds: string[]
): AsyncResult<Entities.Cart> {
    const request = lAC_RemoveCartLinesInput(authToken, cartId, customerId, cartLineIds);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

function lAC_SetOrderNoteQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_SetOrderNoteInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    note: string
): IDataServiceRequest {
    const query = lAC_SetOrderNoteQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_SetOrderNote',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        {
            authToken: authToken,
            cartId: cartId,
            customerId: customerId,
            note: note
        }
    );
}

export function lAC_SetOrderNoteAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    note: string
): AsyncResult<Entities.Cart> {
    const request = lAC_SetOrderNoteInput(authToken, cartId, customerId, note);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

function lAC_AddOrderAllergensQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_AddOrderAllergensInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    allergenCodes: string[]
): IDataServiceRequest {
    const query = lAC_AddOrderAllergensQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_AddOrderAllergens',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        {
            authToken: authToken,
            cartId: cartId,
            customerId: customerId,
            allergenCodes: allergenCodes
        }
    );
}

export function lAC_AddOrderAllergensAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string,
    customerId: string,
    allergenCodes: string[]
): AsyncResult<Entities.Cart> {
    const request = lAC_AddOrderAllergensInput(authToken, cartId, customerId, allergenCodes);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

function lAC_GetAllergensQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_GetAllergensInput(authToken: DataServiceEntities.ILAC_AuthToken, customerId: string): IDataServiceRequest {
    const query = lAC_GetAllergensQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_GetAllergens',
        true,
        DataServiceEntities.GetFoodPreferenceItemsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetFoodPreferenceItemsResponse' },
        {
            authToken: authToken,
            customerId: customerId
        }
    );
}

export function lAC_GetAllergensAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    customerId: string
): AsyncResult<DataServiceEntities.IGetFoodPreferenceItemsResponse> {
    const request = lAC_GetAllergensInput(authToken, customerId);
    return callActionOrExecute<DataServiceEntities.IGetFoodPreferenceItemsResponse>(request, context.callerContext);
}

function lAC_AssignCartCustomerQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_AssignCartCustomerInput(authToken: DataServiceEntities.ILAC_AuthToken, cartId: string): IDataServiceRequest {
    const query = lAC_AssignCartCustomerQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_AssignCartCustomer',
        true,
        EntityClasses.CartClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Cart' },
        {
            authToken: authToken,
            cartId: cartId
        }
    );
}

export function lAC_AssignCartCustomerAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    cartId: string
): AsyncResult<Entities.Cart> {
    const request = lAC_AssignCartCustomerInput(authToken, cartId);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
}

function getCustomerAccountByUUIDQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerAccountByUUIDInput(identificationNumber: string): IDataServiceRequest {
    const query = getCustomerAccountByUUIDQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerAccountByUUID',
        false,
        EntityClasses.CustomerClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.Customer' },
        {
            identificationNumber: identificationNumber
        }
    );
}

export function getCustomerAccountByUUIDAsync(context: IContext, identificationNumber: string): AsyncResult<Entities.Customer> {
    const request = getCustomerAccountByUUIDInput(identificationNumber);
    return callActionOrExecute<Entities.Customer>(request, context.callerContext);
}

function lAC_ITSGetItemNutritionDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_ITSGetItemNutritionDetailsInput(itemId: string): IDataServiceRequest {
    const query = lAC_ITSGetItemNutritionDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_ITSGetItemNutritionDetails',
        true,
        DataServiceEntities.GetCartLineNutritionDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCartLineNutritionDetailsResponse' },
        {
            itemId: itemId
        }
    );
}

export function lAC_ITSGetItemNutritionDetailsAsync(
    context: IContext,
    itemId: string
): AsyncResult<DataServiceEntities.IGetCartLineNutritionDetailsResponse> {
    const request = lAC_ITSGetItemNutritionDetailsInput(itemId);
    return callActionOrExecute<DataServiceEntities.IGetCartLineNutritionDetailsResponse>(request, context.callerContext);
}

function lAC_SuiteToValidateAdminQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_SuiteToValidateAdminInput(
    authToken: DataServiceEntities.ILAC_AuthToken,
    eventId: number,
    suiteId: number
): IDataServiceRequest {
    const query = lAC_SuiteToValidateAdminQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_SuiteToValidateAdmin',
        true,
        DataServiceEntities.LAC_SuiteToValidateAdminExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILAC_SuiteToValidateAdmin' },
        {
            authToken: authToken,
            eventId: eventId,
            suiteId: suiteId
        }
    );
}

export function lAC_SuiteToValidateAdminAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken,
    eventId: number,
    suiteId: number
): AsyncResult<DataServiceEntities.ILAC_SuiteToValidateAdmin> {
    const request = lAC_SuiteToValidateAdminInput(authToken, eventId, suiteId);
    return callActionOrExecute<DataServiceEntities.ILAC_SuiteToValidateAdmin>(request, context.callerContext);
}

function lAC_GetCustomerPaymentMethodQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function lAC_GetCustomerPaymentMethodInput(authToken: DataServiceEntities.ILAC_AuthToken): IDataServiceRequest {
    const query = lAC_GetCustomerPaymentMethodQuery();
    return query.createDataServiceRequestForOperation(
        'LAC_GetCustomerPaymentMethod',
        true,
        DataServiceEntities.LAC_GetCustomerPaymentMethodResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILAC_GetCustomerPaymentMethodResponse' },
        {
            authToken: authToken
        }
    );
}

export function lAC_GetCustomerPaymentMethodAsync(
    context: IContext,
    authToken: DataServiceEntities.ILAC_AuthToken
): AsyncResult<DataServiceEntities.ILAC_GetCustomerPaymentMethodResponse> {
    const request = lAC_GetCustomerPaymentMethodInput(authToken);
    return callActionOrExecute<DataServiceEntities.ILAC_GetCustomerPaymentMethodResponse>(request, context.callerContext);
}

// function sendAiFiDataQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function sendAiFiDataInput(currentCart: Entities.Cart, isConcluded: boolean): IDataServiceRequest {
//     const query = sendAiFiDataQuery();
//     return query.createDataServiceRequestForOperation(
//         'SendAiFiData',
//         true,
//         '',
//         'false',
//         { bypassCache: 'get', returnEntity: '' },
//         {
//             currentCart: currentCart,
//             isConcluded: isConcluded
//         }
//     );
// }

// export function sendAiFiDataAsync(context: IContext, currentCart: Entities.Cart, isConcluded: boolean): AsyncResult<boolean> {
//     const request = sendAiFiDataInput(currentCart, isConcluded);
//     return callActionOrExecute<boolean>(request, context.callerContext);
// }

// function getCustomerRequiredAttrQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function getCustomerRequiredAttrInput(): IDataServiceRequest {
//     const query = getCustomerRequiredAttrQuery();
//     return query.createDataServiceRequestForOperation(
//         'GetCustomerRequiredAttr',
//         true,
//         '',
//         'false',
//         { bypassCache: 'get', returnEntity: '' },
//         {}
//     );
// }

// export function getCustomerRequiredAttrAsync(context: IContext): AsyncResult<boolean> {
//     const request = getCustomerRequiredAttrInput();
//     return callActionOrExecute<boolean>(request, context.callerContext);
// }

// function mCSGetOrdersSentToAiFiQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSGetOrdersSentToAiFiInput(
//     queryResultSettings: IQueryResultSettings,
//     startDate: string,
//     endDate: string,
//     store: string,
//     aiFiStoreId: number
// ): IDataServiceRequest {
//     const query = mCSGetOrdersSentToAiFiQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSGetOrdersSentToAiFi',
//         true,
//         DataServiceEntities.MCSGetOrdersSentToAiFiEntityExtensionClass,
//         'true',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMCSGetOrdersSentToAiFiEntity' },
//         {
//             StartDate: startDate,
//             EndDate: endDate,
//             Store: store,
//             AiFiStoreId: aiFiStoreId
//         }
//     );
// }

// export function mCSGetOrdersSentToAiFiAsync(
//     context: IContext,
//     startDate: string,
//     endDate: string,
//     store: string,
//     aiFiStoreId: number
// ): AsyncResult<DataServiceEntities.IMCSGetOrdersSentToAiFiEntity[]> {
//     const request = mCSGetOrdersSentToAiFiInput(context.queryResultSettings || {}, startDate, endDate, store, aiFiStoreId);
//     return callActionOrExecute<DataServiceEntities.IMCSGetOrdersSentToAiFiEntity[]>(request, context.callerContext);
// }

// function getSuspendedCartsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function getSuspendedCartsInput(
//     queryResultSettings: IQueryResultSettings,
//     suspendedTransactionFilter: DataServiceEntities.IMCSSuspendedTransactionFilterEntity
// ): IDataServiceRequest {
//     const query = getSuspendedCartsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'GetSuspendedCarts',
//         true,
//         Entities.Cart,
//         'true',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             suspendedTransactionFilter: suspendedTransactionFilter
//         }
//     );
// }

// export function getSuspendedCartsAsync(
//     context: IContext,
//     suspendedTransactionFilter: DataServiceEntities.IMCSSuspendedTransactionFilterEntity
// ): AsyncResult<Entities.Cart[]> {
//     const request = getSuspendedCartsInput(context.queryResultSettings || {}, suspendedTransactionFilter);
//     return callActionOrExecute<Entities.Cart[]>(request, context.callerContext);
// }

// function getSuitesSuspendedCartsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function getSuitesSuspendedCartsInput(
//     queryResultSettings: IQueryResultSettings,
//     suitesSuspendedTransactionFilter: DataServiceEntities.IMCSSuitesSuspendedTransactionFilterEntity
// ): IDataServiceRequest {
//     const query = getSuitesSuspendedCartsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'GetSuitesSuspendedCarts',
//         true,
//         Entities.Cart,
//         'true',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             suitesSuspendedTransactionFilter: suitesSuspendedTransactionFilter
//         }
//     );
// }

// export function getSuitesSuspendedCartsAsync(
//     context: IContext,
//     suitesSuspendedTransactionFilter: DataServiceEntities.IMCSSuitesSuspendedTransactionFilterEntity
// ): AsyncResult<Entities.Cart[]> {
//     const request = getSuitesSuspendedCartsInput(context.queryResultSettings || {}, suitesSuspendedTransactionFilter);
//     return callActionOrExecute<Entities.Cart[]>(request, context.callerContext);
// }

// function mCSVoidTenderLineQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSVoidTenderLineInput(
//     cartId: string,
//     tenderLineId: string,
//     reasonCodeLines: Entities.ReasonCodeLine[],
//     isPreprocessed: boolean,
//     forceVoid: boolean
// ): IDataServiceRequest {
//     const query = mCSVoidTenderLineQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSVoidTenderLine',
//         true,
//         Entities.Cart,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             cartId: cartId,
//             tenderLineId: tenderLineId,
//             reasonCodeLines: reasonCodeLines,
//             isPreprocessed: isPreprocessed,
//             forceVoid: forceVoid
//         }
//     );
// }

// export function mCSVoidTenderLineAsync(
//     context: IContext,
//     cartId: string,
//     tenderLineId: string,
//     reasonCodeLines: Entities.ReasonCodeLine[],
//     isPreprocessed: boolean,
//     forceVoid: boolean
// ): AsyncResult<Entities.Cart> {
//     const request = mCSVoidTenderLineInput(cartId, tenderLineId, reasonCodeLines, isPreprocessed, forceVoid);
//     return callActionOrExecute<Entities.Cart>(request, context.callerContext);
// }

// function mCSAddReturnCartLinesQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSAddReturnCartLinesInput(
//     cartId: string,
//     returnCartLines: Entities.ReturnCartLine[],
//     returnTransactionSearchLocation: number,
//     cartVersion: number
// ): IDataServiceRequest {
//     const query = mCSAddReturnCartLinesQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSAddReturnCartLines',
//         true,
//         Entities.Cart,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             cartId: cartId,
//             returnCartLines: returnCartLines,
//             returnTransactionSearchLocation: returnTransactionSearchLocation,
//             cartVersion: cartVersion
//         }
//     );
// }

// export function mCSAddReturnCartLinesAsync(
//     context: IContext,
//     cartId: string,
//     returnCartLines: Entities.ReturnCartLine[],
//     returnTransactionSearchLocation: number,
//     cartVersion: number
// ): AsyncResult<Entities.Cart> {
//     const request = mCSAddReturnCartLinesInput(cartId, returnCartLines, returnTransactionSearchLocation, cartVersion);
//     return callActionOrExecute<Entities.Cart>(request, context.callerContext);
// }

// function mCSGetAllSuspendedCartsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSGetAllSuspendedCartsInput(
//     queryResultSettings: IQueryResultSettings,
//     suspendedTransactionFilter: DataServiceEntities.IMCSSuspendedTransactionFilterEntity
// ): IDataServiceRequest {
//     const query = mCSGetAllSuspendedCartsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSGetAllSuspendedCarts',
//         true,
//         Entities.SuspendedCart,
//         'true',
//         { bypassCache: 'get', returnEntity: 'Entities.SuspendedCart' },
//         {
//             suspendedTransactionFilter: suspendedTransactionFilter
//         }
//     );
// }

// export function mCSGetAllSuspendedCartsAsync(
//     context: IContext,
//     suspendedTransactionFilter: DataServiceEntities.IMCSSuspendedTransactionFilterEntity
// ): AsyncResult<Entities.SuspendedCart[]> {
//     const request = mCSGetAllSuspendedCartsInput(context.queryResultSettings || {}, suspendedTransactionFilter);
//     return callActionOrExecute<Entities.SuspendedCart[]>(request, context.callerContext);
// }

// function mCSSuspendCartsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSSuspendCartsInput(cartId: string, journalCartId: string, receiptNumberSequence: string): IDataServiceRequest {
//     const query = mCSSuspendCartsQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSSuspendCarts',
//         true,
//         Entities.Cart,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             cartId: cartId,
//             journalCartId: journalCartId,
//             receiptNumberSequence: receiptNumberSequence
//         }
//     );
// }

// export function mCSSuspendCartsAsync(
//     context: IContext,
//     cartId: string,
//     journalCartId: string,
//     receiptNumberSequence: string
// ): AsyncResult<Entities.Cart> {
//     const request = mCSSuspendCartsInput(cartId, journalCartId, receiptNumberSequence);
//     return callActionOrExecute<Entities.Cart>(request, context.callerContext);
// }

// function mCSResumeCartQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSResumeCartInput(cartId: string): IDataServiceRequest {
//     const query = mCSResumeCartQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSResumeCart',
//         true,
//         Entities.Cart,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             cartId: cartId
//         }
//     );
// }

// export function mCSResumeCartAsync(context: IContext, cartId: string): AsyncResult<Entities.Cart> {
//     const request = mCSResumeCartInput(cartId);
//     return callActionOrExecute<Entities.Cart>(request, context.callerContext);
// }

// function mCSGetCartsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSGetCartsInput(
//     queryResultSettings: IQueryResultSettings,
//     lastModifiedDateTimeFrom: Date,
//     lastModifiedDateTimeTo: Date
// ): IDataServiceRequest {
//     const query = mCSGetCartsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSGetCarts',
//         true,
//         Entities.Cart,
//         'true',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             lastModifiedDateTimeFrom: lastModifiedDateTimeFrom,
//             lastModifiedDateTimeTo: lastModifiedDateTimeTo
//         }
//     );
// }

// export function mCSGetCartsAsync(
//     context: IContext,
//     lastModifiedDateTimeFrom: Date,
//     lastModifiedDateTimeTo: Date
// ): AsyncResult<Entities.Cart[]> {
//     const request = mCSGetCartsInput(context.queryResultSettings || {}, lastModifiedDateTimeFrom, lastModifiedDateTimeTo);
//     return callActionOrExecute<Entities.Cart[]>(request, context.callerContext);
// }

// function mCSSendReceiptQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSSendReceiptInput(
//     criteria: Entities.SearchReceiptCriteria,
//     recipientAddresses: Entities.ElectronicAddress[]
// ): IDataServiceRequest {
//     const query = mCSSendReceiptQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSSendReceipt',
//         true,
//         DataServiceEntities.NullResponseExtensionClass,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.NullResponse' },
//         {
//             criteria: criteria,
//             recipientAddresses: recipientAddresses
//         }
//     );
// }

// export function mCSSendReceiptAsync(
//     context: IContext,
//     criteria: Entities.SearchReceiptCriteria,
//     recipientAddresses: Entities.ElectronicAddress[]
// ): AsyncResult<Entities.NullResponse> {
//     const request = mCSSendReceiptInput(criteria, recipientAddresses);
//     return callActionOrExecute<Entities.NullResponse>(request, context.callerContext);
// }

// function mCSVoidQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSVoidInput(cartId: string, cartVersion: number): IDataServiceRequest {
//     const query = mCSVoidQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSVoid',
//         true,
//         Entities.SalesOrder,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.SalesOrder' },
//         {
//             cartId: cartId,
//             cartVersion: cartVersion
//         }
//     );
// }

// export function mCSVoidAsync(context: IContext, cartId: string, cartVersion: number): AsyncResult<Entities.SalesOrder> {
//     const request = mCSVoidInput(cartId, cartVersion);
//     return callActionOrExecute<Entities.SalesOrder>(request, context.callerContext);
// }

// function mCSVoidCartLinesQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSVoidCartLinesInput(cartId: string, cartLines: Entities.CartLine[]): IDataServiceRequest {
//     const query = mCSVoidCartLinesQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSVoidCartLines',
//         true,
//         Entities.Cart,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             cartId: cartId,
//             cartLines: cartLines
//         }
//     );
// }

// export function mCSVoidCartLinesAsync(context: IContext, cartId: string, cartLines: Entities.CartLine[]): AsyncResult<Entities.Cart> {
//     const request = mCSVoidCartLinesInput(cartId, cartLines);
//     return callActionOrExecute<Entities.Cart>(request, context.callerContext);
// }

// function lACLGetTransactionByInvoiceQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function lACLGetTransactionByInvoiceInput(invoiceId: string): IDataServiceRequest {
//     const query = lACLGetTransactionByInvoiceQuery();
//     return query.createDataServiceRequestForOperation(
//         'LACLGetTransactionByInvoice',
//         true,
//         Entities.SalesOrder,
//         'false',
//         { bypassCache: 'get', returnEntity: 'Entities.SalesOrder' },
//         {
//             invoiceId: invoiceId
//         }
//     );
// }

// export function lACLGetTransactionByInvoiceAsync(context: IContext, invoiceId: string): AsyncResult<Entities.SalesOrder> {
//     const request = lACLGetTransactionByInvoiceInput(invoiceId);
//     return callActionOrExecute<Entities.SalesOrder>(request, context.callerContext);
// }

// function getCustomerSuspendedCartsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function getCustomerSuspendedCartsInput(queryResultSettings: IQueryResultSettings, customerId: string): IDataServiceRequest {
//     const query = getCustomerSuspendedCartsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'GetCustomerSuspendedCarts',
//         false,
//         Entities.Cart,
//         'true',
//         { bypassCache: 'get', returnEntity: 'Entities.Cart' },
//         {
//             customerId: customerId
//         }
//     );
// }

// export function getCustomerSuspendedCartsAsync(context: IContext, customerId: string): AsyncResult<Entities.Cart[]> {
//     const request = getCustomerSuspendedCartsInput(context.queryResultSettings || {}, customerId);
//     return callActionOrExecute<Entities.Cart[]>(request, context.callerContext);
// }

// function mCSGetChannelAttributesQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSGetChannelAttributesInput(
//     queryResultSettings: IQueryResultSettings,
//     storeId: string,
//     channelId: number,
//     omOperatingUnitId: string
// ): IDataServiceRequest {
//     const query = mCSGetChannelAttributesQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSGetChannelAttributes',
//         true,
//         DataServiceEntities.MCSRetailChannelEntityExtensionClass,
//         'true',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMCSRetailChannelEntity' },
//         {
//             storeId: storeId,
//             channelId: channelId,
//             omOperatingUnitId: omOperatingUnitId
//         }
//     );
// }

// export function mCSGetChannelAttributesAsync(
//     context: IContext,
//     storeId: string,
//     channelId: number,
//     omOperatingUnitId: string
// ): AsyncResult<DataServiceEntities.IMCSRetailChannelEntity[]> {
//     const request = mCSGetChannelAttributesInput(context.queryResultSettings || {}, storeId, channelId, omOperatingUnitId);
//     return callActionOrExecute<DataServiceEntities.IMCSRetailChannelEntity[]>(request, context.callerContext);
// }

// function mCSGetChaseTransactionQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSGetChaseTransactionInput(transactionId: string): IDataServiceRequest {
//     const query = mCSGetChaseTransactionQuery();
//     return query.createDataServiceRequestForOperation(
//         'MCSGetChaseTransaction',
//         true,
//         DataServiceEntities.GetTransactionResponseExtensionClass,
//         'false',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetTransactionResponse' },
//         {
//             transactionId: transactionId
//         }
//     );
// }

// export function mCSGetChaseTransactionAsync(
//     context: IContext,
//     transactionId: string
// ): AsyncResult<DataServiceEntities.IGetTransactionResponse> {
//     const request = mCSGetChaseTransactionInput(transactionId);
//     return callActionOrExecute<DataServiceEntities.IGetTransactionResponse>(request, context.callerContext);
// }

// function mCSGetCustomAttributesQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSGetCustomAttributesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
//     const query = mCSGetCustomAttributesQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSGetCustomAttributes',
//         false,
//         DataServiceEntities.MCSCustomAttributesEntityExtensionClass,
//         'true',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMCSCustomAttributesEntity' },
//         {}
//     );
// }

// export function mCSGetCustomAttributesAsync(context: IContext): AsyncResult<DataServiceEntities.IMCSCustomAttributesEntity[]> {
//     const request = mCSGetCustomAttributesInput(context.queryResultSettings || {});
//     return callActionOrExecute<DataServiceEntities.IMCSCustomAttributesEntity[]>(request, context.callerContext);
// }

// function mCSRemoveCustomerAffiliationsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSRemoveCustomerAffiliationsInput(
//     queryResultSettings: IQueryResultSettings,
//     customerAffiliations: DataServiceEntities.IMCSRemoveCustomerAffiliationEntity[]
// ): IDataServiceRequest {
//     const query = mCSRemoveCustomerAffiliationsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSRemoveCustomerAffiliations',
//         true,
//         DataServiceEntities.LACLPlayFabCustomerAffiliationExtensionClass,
//         'true',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILACLPlayFabCustomerAffiliation' },
//         {
//             customerAffiliations: customerAffiliations
//         }
//     );
// }

// export function mCSRemoveCustomerAffiliationsAsync(
//     context: IContext,
//     customerAffiliations: DataServiceEntities.IMCSRemoveCustomerAffiliationEntity[]
// ): AsyncResult<DataServiceEntities.ILACLPlayFabCustomerAffiliation[]> {
//     const request = mCSRemoveCustomerAffiliationsInput(context.queryResultSettings || {}, customerAffiliations);
//     return callActionOrExecute<DataServiceEntities.ILACLPlayFabCustomerAffiliation[]>(request, context.callerContext);
// }

// function mCSNewRemoveCustomerAffiliationsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSNewRemoveCustomerAffiliationsInput(
//     queryResultSettings: IQueryResultSettings,
//     customerAffiliations: DataServiceEntities.IMCSNewRemoveCustomerAffiliationEntity[]
// ): IDataServiceRequest {
//     const query = mCSNewRemoveCustomerAffiliationsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSNewRemoveCustomerAffiliations',
//         true,
//         DataServiceEntities.MCSNewRemoveCustomerAffiliationEntityExtensionClass,
//         'true',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMCSNewRemoveCustomerAffiliationEntity' },
//         {
//             customerAffiliations: customerAffiliations
//         }
//     );
// }

// export function mCSNewRemoveCustomerAffiliationsAsync(
//     context: IContext,
//     customerAffiliations: DataServiceEntities.IMCSNewRemoveCustomerAffiliationEntity[]
// ): AsyncResult<DataServiceEntities.IMCSNewRemoveCustomerAffiliationEntity[]> {
//     const request = mCSNewRemoveCustomerAffiliationsInput(context.queryResultSettings || {}, customerAffiliations);
//     return callActionOrExecute<DataServiceEntities.IMCSNewRemoveCustomerAffiliationEntity[]>(request, context.callerContext);
// }

// function mCSSaveCustomerAffiliationsQuery(): DataServiceQuery {
//     return new DataServiceQuery();
// }

// export function mCSSaveCustomerAffiliationsInput(
//     queryResultSettings: IQueryResultSettings,
//     customerAffiliations: DataServiceEntities.IMCSSaveCustomerAffiliationEntity[]
// ): IDataServiceRequest {
//     const query = mCSSaveCustomerAffiliationsQuery().resultSettings(queryResultSettings);
//     return query.createDataServiceRequestForOperation(
//         'MCSSaveCustomerAffiliations',
//         true,
//         DataServiceEntities.MCSSaveCustomerAffiliationEntityExtensionClass,
//         'true',
//         { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMCSSaveCustomerAffiliationEntity' },
//         {
//             customerAffiliations: customerAffiliations
//         }
//     );
// }

// export function mCSSaveCustomerAffiliationsAsync(
//     context: IContext,
//     customerAffiliations: DataServiceEntities.IMCSSaveCustomerAffiliationEntity[]
// ): AsyncResult<DataServiceEntities.IMCSSaveCustomerAffiliationEntity[]> {
//     const request = mCSSaveCustomerAffiliationsInput(context.queryResultSettings || {}, customerAffiliations);
//     return callActionOrExecute<DataServiceEntities.IMCSSaveCustomerAffiliationEntity[]>(request, context.callerContext);
// }
